import { useEffect } from 'react';

/**
 * Observer global unique : transforme tout élément `[data-reveal]`
 * en élément qui s'anime à l'entrée dans le viewport.
 *
 * Perf-first : IntersectionObserver natif, pas de lib.
 * À appeler une seule fois depuis App.js.
 */
export function useGlobalScrollReveal() {
  useEffect(() => {
    // Pas d'animation si l'utilisateur a demandé reduced-motion
    if (typeof window === 'undefined') return;
    const mq = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
    if (mq && mq.matches) {
      document.querySelectorAll('[data-reveal]').forEach((el) => el.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -5% 0px' }
    );

    const attach = () => {
      document
        .querySelectorAll('[data-reveal]:not(.is-visible)')
        .forEach((el) => observer.observe(el));
    };
    attach();

    // Re-observe nouveaux éléments quand le DOM change (route change, fetch)
    const mutObserver = new MutationObserver(() => {
      // Throttle l'analyse
      window.requestAnimationFrame(attach);
    });
    mutObserver.observe(document.body, { childList: true, subtree: true });

    return () => {
      observer.disconnect();
      mutObserver.disconnect();
    };
  }, []);
}
